<template>
	<template v-if="name === 'Профиль'">
		<div :class="['link', 'profile-link', { active: isActive, collapsed: collapsed }]">
			<router-link :to="link" @click="toggleMobileMenuInSidebar">
				<slot />
				<transition name="fade">
					<span v-if="!collapsed">
						{{ name }}
					</span>
				</transition>
				<transition name="fade">
					<span v-if="showCount && unreadTaskCounter > 0" class="unread-task__counter">
						{{ unreadTaskCounter }}
					</span>
				</transition>
			</router-link>
			<profile-popover :user="user" :in-side-bar="true" :logout="logout" />
		</div>
	</template>
	<template v-else>
		<n-tooltip placement="left" trigger="hover">
			<template #trigger>
				<router-link
					:to="link"
					:class="['link', { active: isActive, collapsed: collapsed }]"
					@click="toggleMobileMenuInSidebar"
				>
					<slot />
					<transition name="fade">
						<span v-if="!collapsed">
							{{ name }}
						</span>
					</transition>
					<transition name="fade">
						<span v-if="showCount && unreadTaskCounter > 0" class="unread-task__counter">
							{{ unreadTaskCounter }}
						</span>
					</transition>
				</router-link>
			</template>
			<span>{{ name }}</span>
		</n-tooltip>
	</template>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { collapsed } from "@/core/sidebarState";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { useStore } from "vuex";
import { State } from "@/core/store/globalStore";
import { User } from "@/domain/user";
import ProfilePopover from "@/components/ui/profile_card/profilePopover.vue";
import { toggleSidebar } from "@/core/sidebarState";
import { NTooltip } from "naive-ui";

export default defineComponent({
	name: "sidebarLink",
	components: { NTooltip, ProfilePopover },
	props: {
		to: { type: String, required: true },
		link: {
			type: Object as PropType<{ name: string }>,
			required: true,
		},
		name: { type: String, required: true },
		showCount: { type: Boolean, default: false },
		logout: { type: Function },
	},
	setup(props) {
		const route = useRoute();
		const routeName = computed<string | symbol | null | undefined>(() => route.name);
		const isMobileMenuOpen = computed<boolean>(() => store.getters.getMobileMenuIsOpen);
		const isMobile = computed<boolean>(() => store.getters.getIsMobile);

		const toggleMobileMenuInSidebar = () => {
			if (isMobileMenuOpen.value && isMobile.value) {
				store.commit("setMobileMenuIsOpen", false);
				toggleSidebar();
			}
		};

		const isActive = computed(() => {
			if (
				routeName.value === "TaskList" ||
				routeName.value === "TaskListIncoming" ||
				routeName.value === "Home" ||
                routeName.value === "RegistryOutsources"
			) {
				return (
					props.link.name === route.name ||
					(routeName.value === "TaskListIncoming" && props.link.name === "Home")
				);
			} else {
				return route.path === props.to;
			}
		});

		const store = useStore<State>();
		const unreadTaskCounter = computed<number>(() => store.getters.getUnreadTaskCounter);
		const user = computed<User>(() => store.getters.getCurrentUserInfo as User);

		return {
			isActive,
			collapsed,
			unreadTaskCounter,
			user,
			routeName,
			toggleMobileMenuInSidebar,
		};
	},
});
</script>

<style scoped>
.link {
	display: flex;
	align-items: center;

	padding: 10px 0 10px 12px;
	margin-bottom: 6px;

	transition: all 0.4s;
	white-space: nowrap;

	border-radius: 6px;
	color: white;
}

.link.collapsed {
	transition-delay: 0.2s;
	justify-content: center;
	padding: 10px 10px 12px;
}

.link:hover {
	background-color: rgba(255, 255, 255, 0.2);
}

.link.active {
	background-color: white;
	color: #333333;
}

.link span {
	margin-left: 10px;

	line-height: 120%;

	white-space: nowrap;
}

.link.collapsed:has(img) {
	width: 100%;
	padding: 10px 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.unread-task__counter {
	position: static;
	transition: position 0.3s ease-in-out;
	font-size: 12px;
	font-weight: 500;
	padding: 3px 6px;
	color: #ec5555;
	background-color: #ffe7e8;
	border-radius: 4px;
}

.collapsed {
	position: relative;
}

.collapsed .unread-task__counter {
	position: absolute;
	top: -1px;
	left: 12px;
	z-index: 10;
	font-size: 11px;
	font-weight: 600;
	padding: 3px 6px;
	color: #ec5555;
	transition: position 0.3s ease-in-out;
	background-color: #ffe7e8;
	border-radius: 4px;
}

.dark .collapsed {
	.unread-task__counter {
		background-color: var(--dark-bg-700);
	}
}

.sidebar .profile-link.collapsed .profile__popover {
	width: fit-content;
	left: 58px;
	top: 25px;
}

.sidebar .profile-link .profile__popover {
	width: fit-content;
	left: 140px;
	top: 85px;
	z-index: 100;

	@media (max-width: 768px) {
		left: -100px;
		width: 100%;
	}
}

.profile-link .profile__popover {
	opacity: 0;
	visibility: hidden;
	transition: All 0.2s ease-in-out;
}

.profile-link:hover .profile__popover {
	opacity: 1;
	visibility: visible;
}

.profile-link a {
	display: flex;
	align-items: center;
	transition: all 0.4s;
	color: inherit;
}

.profile-link.collapsed a {
	justify-content: center;
	transition-delay: 0.2s;
}
</style>